(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[493],{

/***/ "SQl2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Phone", function() { return Phone; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Phone = function Phone(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 500"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M344.1 320.7c-6.1-6-17-7.2-24.3-2.8l-57.7 36.2c-7.4 4.5-16.9 2.4-21.4-4.9l-81.3-129.6c-4.5-7.3-2.3-16.9 4.9-21.5l54.3-34.1c7.2-4.5 10.5-14.7 7.3-22.6L171.5 9.1c-3.2-7.9-12.2-11.4-19.9-7.7 0 0-74 35.4-84.5 81.2C24.3 269.8 141.2 456.2 328.3 499c45.8 10.4 109.5-63.3 109.5-63.3 5.6-6.5 5.2-16.7-.8-22.7l-92.9-92.3z"
  }));
};

/***/ })

}]);